import type { Stage } from '../lib/types';
import { KanbanColumn } from './kanban-column';
import { Button } from 'components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Filter, ArrowUpDown } from 'lucide-react';

interface KanbanBoardProps {
  stages: Stage[];
}

export function KanbanBoard({ stages }: KanbanBoardProps) {
  console.log({ stages });
  return (
    <div className="bg-slate-50 min-h-screen p-0">
      {/* <div className="flex justify-between items-center mb-6">
        <Button variant="outline" className="bg-white">
          <Filter className="mr-2 h-4 w-4" /> Pin filters
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              className="bg-blue-50 hover:bg-blue-100 text-blue-700 border-blue-200"
            >
              <ArrowUpDown className="mr-2 h-4 w-4" /> Sort by: Next activity
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem>Next activity</DropdownMenuItem>
            <DropdownMenuItem>Creation date</DropdownMenuItem>
            <DropdownMenuItem>Value</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div> */}
      <div className="flex space-x-2 overflow-x-auto pb-4">
        {stages.map((stage) => (
          <KanbanColumn key={stage.id} stage={stage} />
        ))}
      </div>
    </div>
  );
}
